import React from "react";
import styled from "styled-components";
import { Tooltip } from "@mui/material";
import { useAuth } from "../../../components/providers/auth-context";
import { useTeam } from "./team-provider";

const HtmlTooltip = styled(Tooltip)`
    cursor: pointer;
`;

const OnlyOwnerTooltip = ({ children }) => {
    const { user } = useAuth();
    const teamApi = useTeam();

    const ownerId = teamApi && teamApi.data && teamApi.data.owner && teamApi.data.owner.id;

    if (user.id === ownerId) return children;

    return (
        <HtmlTooltip title="Only Team Owners can perform this action">
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "inherit",
                    alignItems: "inherit",
                }}
            >
                {children}
            </div>
        </HtmlTooltip>
    );
};

export default OnlyOwnerTooltip;
